import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';

const ModalRequireCheckbox = ({
  label,
  name,
  checked,
  last,
  handleChange,
}) => (
  <div className={classnames('require-checkbox require-setting', { last })}>
    <Label for={`inp${name}`} className="switch">
      {label}
      <div className="switch-control input-inner">
        <Input
          type="checkbox"
          name={name}
          id={`inp${name}`}
          value={true}
          checked={checked}
          onChange={handleChange}
        />
        <i />
      </div>
    </Label>
  </div>
);

ModalRequireCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  last: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

ModalRequireCheckbox.defaultProps = {
  last: false,
};

export default ModalRequireCheckbox;
